import http from "./http";

//#region API endpoints
const login = (data) => {
  return http.post("/login", data);
}
const customerRequestReset = (data) => {
  return http.post("/customer-reset-password-request", data);
}
const getActiveCategory = () => {
  return http.get("/get-active-category");
}
const customerVerifyOtp = (data) => {
  return http.post("/customer-reset-password-verify-otp", data);
}
const customerResetPassword = (data) => {
  return http.post("/customer-reset-password-reset", data);
}
const getSocialMediaByCompany = (data) => {
  return http.post("/get-social-confugiration", data);
}
const aadhaarSendOtp = (data) => {
  return http.post("/send-otp", data);
}
const aadharVerifyOtp = (data) => {
  return http.post("/verify-otp", data);
}
const createEnquiry = (data) => {
  return http.post("/create-enquiry", data);
}
const customerCount = (data) => {
  return http.post("/customer-count", data);
}
const increaseRegisterVisit = (data) => {
  return http.post("/increase-visitor-count", data);
}
const getRegisterVisit = () => {
  return http.get("/get-visitor-count");
}
const getCountryList = (data) => {
  return http.post("/get-country", data);
}
const getStateList = (data) => {
  return http.post("/get-state", data);
}
const getPodcasts = () => {
  return http.post("/get-all-podcast");
}
const getUserProfile = (data) => {
  return http.post("/get-user-profile", data);
}
const updateUserProfile = (data) => {
  return http.post("/update-user-profile", data);
}
const getResourceData = (data) => {
  return http.post("/get-podcast-by-category", data);
}
const getPatrikaImagesByResourceId = (data) => {
  return http.post("/get-patrika-images-pdf", data);
}
const getKuldeviListForCustomer = (data) => {
  return http.post("/get-kuldevi-list-for-customer", data);
}
const getGotraList = (data) => {
  return http.post("/get-gotra-list-for-customer", data);
}
const getBookImagesByResourceId = (data) => {
  return http.post("/get-book-images-pdf", data);
}
const getKuldeviDetailsForCustomerSide = (data) => {
  return http.post("/get-kuldevi-details-category", data);
}
const downloadGotraPdf = (data) => {
  return http.post("/download-gotra-pdf", data);
}
const downloadKuldeviPdf = (data) => {
  return http.post("/download-kuldevi-pdf", data);
}
const getBlogger = (data) => {
  return http.post("/get-blogger", data);
}
const getBlogById = (data) => {
  return http.post("/get-blog-by-id", data);
}
const getArtPhotographyImages = (data) => {
  return http.post("/get-art-and-photography-images", data);
}

const config = {
  login,
  getActiveCategory,
  customerRequestReset,
  customerVerifyOtp,
  customerResetPassword,
  getSocialMediaByCompany,
  aadhaarSendOtp,
  aadharVerifyOtp,
  createEnquiry,
  customerCount,
  increaseRegisterVisit,
  getRegisterVisit,
  getCountryList,
  getStateList,
  getPodcasts,
  getUserProfile,
  updateUserProfile,
  getResourceData,
  getPatrikaImagesByResourceId,
  getKuldeviListForCustomer,
  getGotraList,
  getBookImagesByResourceId,
  getKuldeviDetailsForCustomerSide,
  downloadGotraPdf,
  downloadKuldeviPdf,
  getBlogger,
  getBlogById,
  getArtPhotographyImages,
};

export default config;
//#endregion
